/**
 * UI elements
 */
class MWF_UI {
    constructor() {
        this.initHeaderCountDown();
        this.initExternalLinksAttributes();
        this.initMWFDialog();
        this.initTestimonialReadMore();
        this.initProductWithOpinions();
        this.initSidebarStyles();
        this.initProductCards();
        this.initMWFFakeButtons();
    }

    initHeaderCountDown () {
        if (!$('.js-notification-countdown').length) {
            return;
        }

        $('.js-notification-countdown').each((i, countdown) => {
            mwfCalculateCountdown($(countdown));
        });
    }

    initExternalLinksAttributes () {
        $('.page-content a, .text-content a, .post-content a').each((i, link) => {
            let linkUrl = $(link).attr('href');

            if (!linkUrl || linkUrl.indexOf(window.location.hostname) > -1 || linkUrl.indexOf('#') === 0) {
                return;
            }

            if (!$(link).attr('target')) {
                $(link).attr('target', '_blank');
            }

            let linkRel = $(link).attr('rel');

            if (!linkRel) {
                $(link).attr('rel', 'noopener noreferrer');
            } else if (linkRel.indexOf('noreferrer') === -1) {
                $(link).attr('rel', linkRel + ' noopener noreferrer');
            }
        });
    }

    initMWFDialog () {
        let dialog = document.querySelector('.mwf-dialog');
        let closeButton = document.querySelector('.mwf-dialog-close');
        let dialogContent = dialog.querySelector('.mwf-dialog-content');

        let openDialog = (event) => {
            let sourceElement= event.detail.sourceElement;
            
            if (sourceElement) {
                dialogContent.innerHTML = sourceElement.outerHTML;
            }

            dialog.classList.remove('hide');
            dialog.showModal();

            setTimeout(() => {
                dialog.classList.add('show');
            }, 0);
        };

        let closeDialog = () => {
            dialog.classList.remove('show');
            dialog.classList.add('hide');
            
            setTimeout(() => {
                dialog.close();
            }, 325);
        };

        closeButton.addEventListener('click', closeDialog);

        dialog.addEventListener('click', (e) => {
            if (e.target === dialog) {
                closeDialog();
            }
        });

        document.addEventListener('open-mwf-dialog', openDialog);
    }

    initTestimonialReadMore () {
        let testimonialTexts = document.querySelectorAll('.testimonial-text:not(.has-checked-height)');

        if (!testimonialTexts.length) {
            return;
        }

        testimonialTexts.forEach(textElement => {
            if (textElement.clientHeight > 0) {
                textElement.classList.add('has-checked-height');
            }

            if (textElement.scrollHeight - textElement.clientHeight >= 10) {
                textElement.classList.add('is-readmore');
                textElement.parentNode.addEventListener('click', () => {
                    document.dispatchEvent(new CustomEvent('open-mwf-dialog', {
                        detail: { 
                            sourceElement: textElement.parentNode.parentNode 
                        }
                    }));
                });
            }
        });
    }

    initProductWithOpinions () {
        let blocks = $('.product-with-opinions');

        if (blocks.length) {
            blocks.each((i, block) => {
                let moreBtn = $(block).find('.button-show-more');

                if (moreBtn.length) {
                    moreBtn.on('click', (e) => {
                        e.preventDefault();
                        moreBtn.parent().parent().find('.testimonial[hidden]').each((i, testimonial) => {
                            $(testimonial).removeAttr('hidden');
                            moreBtn.attr('hidden', true);
                        });

                        setTimeout(() => {
                            this.initTestimonialReadMore();
                        }, 0);
                    });
                }
            });
        }
    }

    initSidebarStyles () {
        if (!$('.page-sidebar-wrapper, .post-sidebar-wrapper').length) {
            return;
        }

        window.mwfSimplebarInstance = null;
        let mediaQuery = window.matchMedia("(min-width: 1024px)");
        let self = this;

        function handleMediaQueryChange(e) {
            self.applySidebarStyles();
        }

        mediaQuery.addListener(handleMediaQueryChange);
        this.applySidebarStyles(); 
    }

    applySidebarStyles () {
        let sidebarWrapper = $('.page-sidebar-wrapper, .post-sidebar-wrapper');
        let windowWidth = $(window).width();
        
        if (windowWidth >= 1024) {
          sidebarWrapper.css({
            'max-height': 'calc(100vh - (120px + var(--wp-admin--admin-bar--height, 0px) + var(--mwf-topbar-offset, 0px)))'
          });
      
          if (!window.mwfSimplebarInstance) {
            window.mwfSimplebarInstance = new SimpleBar(sidebarWrapper[0], { autoHide: true });
          }
        } else {
          sidebarWrapper.css({
            'overflow': '',
            'max-height': ''
          });
      
          $(window).off('scroll');
         
          if (window.mwfSimplebarInstance) {
            window.mwfSimpleBarInstance = null;
            sidebarWrapper[0].SimpleBar = null; 
            sidebarWrapper[0].removeAttribute('data-simplebar');
            sidebarWrapper[0].innerHTML = sidebarWrapper[0].querySelector('.simplebar-content').innerHTML;
      
            setTimeout(() => {
              window.mwfSimplebarInstance = null;
            }, 0);
          }
        }
    }

    initProductCards () {
        let cards = $('.eproduct-shop');

        if (!cards.length) {
            return;
        }

        for (let i = 0; i < cards.length; i++) {
            let link = cards.eq(i).find('.button, .button-secondary');

            if (link.length) {
                cards.eq(i).addClass('is-clickable');
                cards.eq(i).on('click', e => {
                    if (e.metaKey || e.ctrlKey) {
                        window.open(link.eq(0).attr('href'), '_blank');
                    } else {
                        window.location.href = link.eq(0).attr('href');
                    }
                });
            }
        }
    }

    initMWFFakeButtons () {
        let fakeBtns = $('*[data-mwf-href]');

        for (let i = 0; i < fakeBtns.length; i++) {
            let btn = fakeBtns.eq(i);
            btn.css('cursor', 'pointer');
            btn.on('click', () => {
                window.location.href = btn.attr('data-mwf-href');
            });
        }
    }
}

function mwfCalculateCountdown (countdown) {
    let countTo = parseInt(countdown.attr('data-timestamp-utc'), 10) * 1000;
    let currentTime = new Date().getTime();

    if (countTo - currentTime > 60 * 1000) {
        let diff = countTo - currentTime;
        let days = Math.floor(diff / (24 * 60 * 60 * 1000));
        let hoursDiff = diff - (days * 24 * 60 * 60 * 1000);
        let hours = (Math.floor(hoursDiff / (60 * 60 * 1000))) % 24;
        let minutesDiff = hoursDiff - (hours * 60 * 60 * 1000);
        let minutes = (Math.floor(minutesDiff / (60 * 1000))) % 60;
        let daysSuffix = days === 1 ? ' dzień' : ' dni';
        let hoursSuffix = ' godzin ';
        let minutesSuffix = ' minut ';

        if (hours === 1) {
            hoursSuffix = ' godzina ';
        } else if (hours === 2 || hours === 3 || hours === 4 || hours === 22 || hours === 23) {
            hoursSuffix = ' godziny ';
        }

        if (minutes === 1) {
            minutesSuffix = ' minuta ';
        } else if (
            minutes === 2 || minutes === 3 || minutes === 4 || 
            minutes === 22 || minutes === 23 || minutes === 24 || 
            minutes === 32 || minutes === 33 || minutes === 34 || 
            minutes === 42 || minutes === 43 || minutes === 44 || 
            minutes === 52 || minutes === 53 || minutes === 54
        ) {
            minutesSuffix = ' minuty ';
        }

        let outputText = '';

        if (days > 0) {
            outputText += days + daysSuffix;
        }

        if (hours > 0) {
            if (days > 0 && minutes === 0) {
                outputText += ' i ';
            } else if (days > 0) {
                outputText += ', ';
            }

            outputText += hours + hoursSuffix;
        }

        if (minutes > 0) {
            if (days > 0 || hours > 0) {
                outputText += ' i ';
            }

            outputText += minutes + minutesSuffix;
        }

        countdown.text(outputText);

        setTimeout(() => {
            mwfCalculateCountdown (countdown);
        }, 30 * 1000);
    } else {
        countdown.text('czas minął!');
    }
}